import React, { memo } from "react"

import { Upload2 } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { bool, func, shape, string } from "prop-types"

function PreviewUpload({
  fileRef,
  thumbnailUrl = "",
  disabled,
  onFileChange: handleFileChange,
  onUploadClick,
}) {
  return (
    <>
      <div className="environment-settings__preview">
        {thumbnailUrl && <img src={thumbnailUrl} alt="HDRI preview" className="environment-settings__preview-image" />}
      </div>
      <input
        ref={fileRef}
        type="file"
        accept=".hdr,.exr"
        onChange={handleFileChange}
        disabled={disabled}
        hidden
      />
      <button
        type="button"
        className="environment-settings__upload cgt-link-primary"
        onClick={onUploadClick}
        disabled={disabled}
      >
        <Upload2 width="16" height="16" />
        <span>Upload HDRI</span>
      </button>
    </>
  )
}

PreviewUpload.propTypes = {
  fileRef: shape({ current: shape({ click: func }) }).isRequired,
  thumbnailUrl: string,
  disabled: bool.isRequired,
  onFileChange: func.isRequired,
  onUploadClick: func.isRequired,
}

export default memo(PreviewUpload)
